'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Uniform = require('../../Uniform');

var _feedUserUtil = require('../../../utils/feed-user-util');

var _feedUserUtil2 = _interopRequireDefault(_feedUserUtil);

var _FollowButtonApp = require('../FollowButtonApp');

var _FollowButtonApp2 = _interopRequireDefault(_FollowButtonApp);

var _propTypes = require('../../../shared/prop-types');

var spt = _interopRequireWildcard(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-multi-comp */


var getSchoolInfo = function getSchoolInfo(schoolName, schoolLocation) {
  if (schoolName && schoolLocation) {
    return _react2.default.createElement(
      'span',
      null,
      schoolName,
      ' \u2022 ',
      schoolLocation
    );
  }

  return schoolName || schoolLocation;
};

var UserRow = function (_PureComponent) {
  _inherits(UserRow, _PureComponent);

  function UserRow() {
    _classCallCheck(this, UserRow);

    return _possibleConstructorReturn(this, (UserRow.__proto__ || Object.getPrototypeOf(UserRow)).apply(this, arguments));
  }

  _createClass(UserRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$user = this.props.user,
          feedUserId = _props$user.feedUserId,
          _props$user$followers = _props$user.followersCount,
          followersCount = _props$user$followers === undefined ? 0 : _props$user$followers,
          imageUrl = _props$user.imageUrl,
          name = _props$user.name,
          school = _props$user.school,
          schoolLocation = _props$user.schoolLocation,
          schoolName = _props$user.schoolName,
          url = _props$user.url;


      var schoolDisplay = schoolName || school;
      var schoolInfo = getSchoolInfo(schoolDisplay, schoolLocation);
      var initials = _feedUserUtil2.default.getFeedUserInitials(name);
      var imageAvatar = imageUrl.indexOf('thumb-user.svg') > 1 ? '' : imageUrl;

      return _react2.default.createElement(
        'div',
        { className: 'feed-modal-user-row' },
        _react2.default.createElement(
          'a',
          { className: 'user-avatar', href: url, title: name, onClick: this.props.onClickProfile },
          _react2.default.createElement(_Uniform.AvatarUser, { initials: initials, imageUrl: imageAvatar, size: 'medium', className: 'uni-margin--half--right' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'user-fields' },
          _react2.default.createElement(
            'a',
            { className: 'username', href: url, title: name, onClick: this.props.onClickProfile },
            _react2.default.createElement(
              _Uniform.Subhead,
              { level: 'small' },
              name
            )
          ),
          schoolInfo ? _react2.default.createElement(
            _Uniform.Text,
            { level: 'small', color: 'subtle' },
            schoolInfo
          ) : null,
          followersCount ? _react2.default.createElement(
            _Uniform.Text,
            { level: 'micro', color: 'nonessential' },
            followersCount,
            ' followers'
          ) : null
        ),
        this.props.showFollowButton ? _react2.default.createElement(
          'div',
          { className: 'follow-user' },
          _react2.default.createElement(_FollowButtonApp2.default, { feedUserId: feedUserId, logData: this.props.logData })
        ) : null
      );
    }
  }]);

  return UserRow;
}(_react.PureComponent);

UserRow.propTypes = {
  logData: _react.PropTypes.object.isRequired,
  onClickProfile: _react.PropTypes.func.isRequired,
  showFollowButton: _react.PropTypes.bool,
  user: spt.ReactionUserDetails.isRequired
};
UserRow.defaultProps = {
  logData: {},
  showFollowButton: true
};
exports.default = UserRow;